export default __webpack_public_path__ + "static/img-nhs-platelet-supply-chain-d77a3769db47f8d8bd3451b6579113b3.webp";